import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEn from './locales/en/common.json';
import translationEn from './locales/en/translation.json';
import errorsEn from './locales/en/errors.json';

import commonDe from './locales/de/common.json';
import translationDe from './locales/de/translation.json';
import errorsDe from './locales/de/errors.json';

export const SUPPORTED_LOCALES = ['de', 'en'] as const;
export const DEFAULT_LOCALE = SUPPORTED_LOCALES[0];

export type Locale = (typeof SUPPORTED_LOCALES)[number];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['localStorage'],
    },
    resources: {
      en: {
        common: commonEn,
        translation: translationEn,
        errors: errorsEn,
      },
      de: {
        common: commonDe,
        translation: translationDe,
        errors: errorsDe,
      },
    },
    ns: ['common', 'translation', 'errors'],
    defaultNS: 'translation',
    supportedLngs: SUPPORTED_LOCALES,
    fallbackLng: DEFAULT_LOCALE,
    interpolation: {
      escapeValue: false,
    },
    // debug: import.meta.env.DEV,
  });

export default i18n;
